import React from "react";
import hr from "../../assets/hr.webp"; // Sample image, replace with actual path
import briefcase from "../../assets/case.webp"; // Sample image, replace with actual path
import doc_ic from "../../assets/document-ic.png";
import taskIcon from "../../assets/task-ic.png";
import meetingIcon from "../../assets/meeting-ic.png";
import projectIcon from "../../assets/projects-lc.png";
import { blue, amber } from "@mui/material/colors";
import { Grid2, Box } from "@mui/material";

function Careers() {
    const features = [
        {
            icon: projectIcon,
            title: "Learning and Development Opportunities",
            description:
                "We provide tools and mentorship to help you excel in your career.",
            color: blue[700],
        },
        {
            icon: taskIcon,
            title: "Work-Life Balance",
            description:
                "Enjoy flexible work arrangements and a supportive culture.",
            color: amber[600],
        },
        {
            icon: meetingIcon,
            title: "Inclusive Work Culture",
            description:
                "We foster a diverse, collaborative, and inclusive workplace.",
            color: amber[600],
        },
        {
            icon: doc_ic,
            title: "Competitive Compensation",
            description:
                "Your contributions are valued, and we offer industry-leading pay and benefits.",
            color: blue[700],
        },
    ];
    return (
        <div className="careers-page">
            <h1 className="h1-48-600">Careers</h1>

            <img
                src={hr} // Sample image
                alt="Working Professional"
                className="header-image"
            />
            <div className="grid-container space1">
                <Grid2 container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    {features.map((feature, index) => (
                        <Grid2 key={index} size={{ xs: 12, sm: 12, md: 6 }} className="grid-item">
                            <div className="feature-item">
                                <div className="feature-top">
                                    <Box
                                        sx={{
                                            width: { xs: 24, sm: 30, md: 48, lg: 52 },
                                            height: { xs: 24, sm: 30, md: 48, lg: 52 },
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "20px",
                                            bgcolor: feature.color,
                                            margin: "10px",
                                            borderRadius: "20px",
                                        }}
                                    >
                                        <img src={feature.icon} alt="Feature icon" />
                                    </Box>
                                    <p className="feature-item-title">
                                        {feature.title}
                                    </p>
                                </div>
                                <div className="feature-content">
                                    <p className="feature-item-text">
                                        {feature.description}
                                    </p>
                                </div>
                            </div>
                        </Grid2>
                    ))}
                </Grid2>
            </div>
            <section className="journey">
                <h2 className="h1-48-600">Join <span>Our</span> Journey</h2>
                <p className="ft-para">
                    At ConRa, we're closing the trust gap in the built environment. For as long as anything has been built, the record of how it was built has rested on paperwork and good faith — photos that can be edited, reports taken on trust. And now AI has made fake and altered imagery cheap and effortless, so a photo no longer proves anything on its own. We're replacing that with proof: GPS-locked, cryptographically signed, tamper-evident records that banks, lenders, and partners can verify for themselves.
                </p>
                <p className="ft-para">
                    This is bigger than software. As the built environment moves toward digital twins and data-driven finance, every one of those systems is only as trustworthy as the data beneath it. We're building that missing layer — the trust infrastructure a global construction industry can run on:
                </p>
            </section>

            <section className="job-openings">
                <h2 className="h1-48-600">Current <span>Job</span> Openings</h2>
                <p className="ft-para">We're always looking for creative and talented individuals to join our Team</p>

                {/* <div className="no-openings">
                    <div className="">
                        <img src={briefcase} alt="Briefcase Icon" className="icon" />
                    </div>
                    <h3>No Current Openings</h3>
                    <p className="ft-para">
                        We don’t have any specific roles open right now, but we are always excited to hear from talented individuals. If you believe you’d be a great fit for our team, we’d love for you to get in touch!
                    </p>
                    <button className="cta-button">Hola At Us</button>
                </div> */}
            </section>

            <footer className="footer-note">
                You can also follow us on our social media channels to stay updated on future opportunities
            </footer>
        </div>
    );
}

export default Careers;
